import React, { useEffect, useState } from "react";
import Dropdown from "../../css/dropdown.module.scss";
import { Button, Card, Paper, Stack, Typography } from "@mui/material";
import DateTimePickerStartViewRenderers from "../coupon/DateTimePickerStart";
import DateTimePickerEndViewRenderers from "../coupon/DateTimePickerEnd";
import auth from "../../config/authaxios";


const DailyWithdraw = () => {
  const [isType, setisType] = useState("TopupX");
  const [category, setCategory] = useState("1");
//   const [page, setPage] = useState(0);
  const [startTime, setStartTime] = useState()
  const [endTime, setEndTime] = useState()
  const [expiryData,setExpiryData]=useState([])

  const searchHandler=()=>{
    fetchVouchers()
  }

  let fetchVouchers = () => {
    let obj={
    "s_date":startTime,
    "e_date":endTime,
    "platfrom":isType,
    "status":"COMPLETE",
    "category":category

    }
    auth.post(`/admin/total-withdrawals`,obj)
      .then((res) => {
        const data = res.data?.response
        setExpiryData(data)
      }).catch((err) => {
        console.log("err", err)
      })
  }

  useEffect(()=>{
    fetchVouchers()
  },[isType])
  return (
    <div style={{minHeight:"50vh"}}>
      <Stack spacing={2} direction="row">
        <div className={Dropdown.dropdown}>
          <Button
            variant="contained"
            color="info"
            sx={{ my: 2 }}
            className={Dropdown.dropbtn}
          >
            Type:
            {isType}
          </Button>
          <div className={Dropdown.dropdown_content} style={{ zIndex: "10" }}>
            <a
              onClick={() => {
                setisType("TopupX");
                // setPage(0);
              }}
            >
              TopupX
            </a>
            <a
              onClick={() => {
                setisType("GamerPe");
                // setPage(0);
              }}
            >
              GamerPe
            </a>
            {/* <a
              onClick={() => {
                setisType("3");
                // setPage(0);
              }}
            >
              Google Play
            </a> */}
          </div>
        </div>

        <div className={Dropdown.dropdown}>
          <Button
            variant="contained"
            color="info"
            sx={{ my: 2 }}
            className={Dropdown.dropbtn}
          >
            Category:
            {category == "1"
              ? "quick silver"
              : category == "2"
              ? "khiladi adda"
              : category == "3"
              ? "GP"
              :category == "4"
              ? "UPI"
              : " "}
          </Button>
          <div className={Dropdown.dropdown_content} style={{ zIndex: "10" }}>
            <a
              onClick={() => {
                setCategory("1");
                // setPage(0);
              }}
            >
              Quick silver
            </a>
            <a
              onClick={() => {
                setCategory("2");
                // setPage(0);
              }}
            >
                Khiladi adda
            </a>
            <a
              onClick={() => {
                setCategory("3");
                // setPage(0);
              }}
            >
              GP
            </a>
            <a
              onClick={() => {
                setCategory("4");
                // setPage(0);
              }}
            >
              UPI
            </a>
          </div>
        </div>
      </Stack>
      <Stack spacing={2} direction='row' sx={{ mb: 2 }}>
          <DateTimePickerStartViewRenderers setStartTime={setStartTime}/>
          <DateTimePickerEndViewRenderers setEndTime={setEndTime}/>
          {startTime && endTime && <Button variant="contained" onClick={searchHandler}>Search</Button>}
      </Stack>
      <div>
        

        {/* <h1>hello world</h1> */}

        {
            expiryData.length>0 ? expiryData.map((item,index)=>{
                return (
                    <div key={index} style={{fontSize:"20px"}}>
                       <span >{item?._id}</span> - <span>{item.amount}</span>
                    </div>
                )

            }):"No History"
        }
        {/* {JSON.stringify(expiryData)} */}
        </div>
    </div>
  );
};

export default DailyWithdraw;
